const Trash = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => {
    return (
        <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M11.9881 25.7797C10.9196 25.5984 9.94768 25.0417 9.24186 24.2066C8.88186 23.7289 8.60003 23.1954 8.40722 22.6265C7.95366 21.5225 7.90352 20.2901 8.26587 19.1518C8.46578 18.5909 8.84495 18.1143 9.34277 17.7981C9.8406 17.4819 10.4284 17.3445 11.0121 17.4077C11.8468 17.565 12.5131 18.2353 13.3343 18.4542C14.7949 18.8509 16.195 17.7702 17.6354 17.3119C18.5035 17.0244 19.4272 16.954 20.3278 17.1067C20.7407 17.166 21.1397 17.3004 21.5057 17.5034C22.048 17.8904 22.4524 18.4452 22.6587 19.0851C22.8649 19.7249 22.8619 20.4154 22.65 21.0533C22.1905 22.3265 21.307 23.3961 20.1528 24.0766C17.7101 25.595 14.8219 26.1975 11.9881 25.7797Z"
                fill="#EF8078"
            />
            <path
                d="M23.1277 9.16552C25.9076 7.11354 17.1035 6.01231 17.1035 6.01231C17.1035 6.01231 17.9381 3.67989 15.8717 3.34473C13.8053 3.00957 13.9332 5.56771 13.9332 5.56771C12.0014 5.24623 6.37431 5.10943 6.22623 6.43638C6.05795 8.06429 16.0063 10.3215 22.32 9.66484C22.6566 9.63064 21.445 25.1505 21.2431 25.3967C19.7757 27.2025 9.43691 27.0178 7.92244 25.3967C7.7407 25.2052 7.1753 11.3338 7.30319 10.6293C7.39742 10.1163 13.3611 13.4815 21.2094 11.1833"
                stroke="#686058"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M11.665 13.4952C11.5775 17.4419 11.665 20.7114 11.9343 24.6512"
                stroke="#686058"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M17.5408 13.6799C17.386 15.2462 16.8677 24.6238 16.8677 24.6238"
                stroke="#686058"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
        </svg>
    )
}

export default Trash
